export const authorSlugs = ['avtor', 'intervyuer', 'perevodchik'];
